/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Warning_DescriptionInputs */

const en_delete_warning_description = /** @type {(inputs: Delete_Warning_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone and all data will be lost.`)
};

const nl_delete_warning_description = /** @type {(inputs: Delete_Warning_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze actie kan niet ongedaan worden gemaakt en alle gegevens gaan verloren.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone and all data will be lost." |
*
* @param {Delete_Warning_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const delete_warning_description = /** @type {((inputs?: Delete_Warning_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Warning_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_delete_warning_description(inputs)
	return en_delete_warning_description(inputs)
});